import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f555e9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer-content" }
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = { class: "filter-monitor" }
const _hoisted_4 = { class: "agents-table-filter-checkbox-container" }
const _hoisted_5 = { class: "filter-monitor" }
const _hoisted_6 = { class: "filter-slider-container filter-slider-container--cpu" }
const _hoisted_7 = ["data-testid"]
const _hoisted_8 = { class: "filter-monitor" }
const _hoisted_9 = { class: "filter-monitor" }
const _hoisted_10 = { class: "agents-table-filter-checkbox-container" }
const _hoisted_11 = { class: "clear-all-btn--container full-width column items-start" }

import RangeSlider from '@/components/inputs/RangeSlider.vue';
import { computed, inject, ref, watch } from 'vue';
import { Agent_Status, useAgentsFiltersMetadataQuery, useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import { IKAgentsDrawerFilter } from '@/types/injectionKeys';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { IKAgentsSelected } from '@/views/agents/components/agents-table/agents-table.InjectionKeys';
import { OsType } from '@/modules/platformAuthentication/platformAuthentication.const';
import elementsIds from '@/const/elementIds.json';
import { BuildGroup } from '@/graphql/codegen/gql/graphql';
import { useMatomo } from '@/services/matomo/matomo.service';
import IncrediCheckBox from '../../../../../../inputs/incrediCheckBox.vue';
import AgentsLicenseFilter from './licenseFilter/agents-license-filter.linux.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AgentTableFilters.linux',
  setup(__props) {

const coordinatorsService = inject(IKCoordinatorsService);
const agentsFilter = inject(IKAgentsDrawerFilter);
const selectedAgents = inject(IKAgentsSelected);
const matomo = useMatomo();

// const store = useStore();
const getFilters = computed(() => agentsFilter?.filter.value);
const GQL_AppDataQuery = useCommonDataQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }));
const GQL_agentsFilterMetadata = useAgentsFiltersMetadataQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }), {
  pollInterval: 5000,
});
const filtersOpen = ref({
  statusOpen: false,
  cpuOpen: false,
  buildGroupOpen: false,
  licenseOpen: false,
});

const toggleOpenFilter = (filterName: keyof typeof filtersOpen.value, value: boolean) => {
  filtersOpen.value = { ...filtersOpen.value, [filterName]: value };
  matomo?.trackEvent({
    category: 'Agents Filter',
    action: 'Open/ Close Filter',
    name: filterName,
    value: value ? 1 : 0,
  });
};

const getBuildGroups = computed(() => (GQL_agentsFilterMetadata?.result.value?.ibManagerEntities?.buildGroups || []).filter(buildGroup => buildGroup) as BuildGroup[]);
const sortBuildGroupsByAlphabetic = computed(() => {
  const list = [...getBuildGroups.value].map(bg => bg?.name) as string[];
  return list.sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
});

const getStatusFilter = computed(() => getFilters.value.status);

watch(
  () => GQL_agentsFilterMetadata?.result?.value?.ibManagerEntities?.settingsMetadata?.isCloudActivated,
  newValue => {
    if (newValue === undefined) return;
    if (!newValue && getFilters.value.status[Agent_Status.Stopped.toLowerCase()]) {
      delete getFilters.value.status[Agent_Status.Stopped.toLowerCase()];
    } else if (newValue && !getFilters.value.status[Agent_Status.Stopped.toLowerCase()]) {
      agentsFilter?.updateFilter({
        group: 'status',
        filter: Agent_Status.Stopped.toLowerCase(),
        value: getFilters.value.status[Agent_Status.Stopped.toLowerCase()] === undefined ? true : getFilters.value.status[Agent_Status.Stopped.toLowerCase()],
      });
    }
  },
  { immediate: true },
);

watch(
  () => GQL_AppDataQuery?.result?.value?.ibManagerEntities?.license?.linux?.licenseDetails,
  newValue => {
    if (newValue === undefined) return;
    const SUVMDetails = newValue?.filter((item: any) => item?.packageType === 2)[0];
    const hasSUVMInLicense = (SUVMDetails?.packageNumCores || 0) - (SUVMDetails?.coresInUse || 0);
    if (!hasSUVMInLicense) {
      delete getFilters.value.status[Agent_Status.Expired.toLowerCase()];
    } else if (hasSUVMInLicense && !getFilters.value.status[Agent_Status.Expired.toLowerCase()]) {
      agentsFilter?.updateFilter({
        osType: OsType.Linux,
        group: 'status',
        filter: Agent_Status.Expired.toLowerCase(),
        value: getFilters.value.status[Agent_Status.Expired.toLowerCase()] === undefined ? true : getFilters.value.status[Agent_Status.Expired.toLowerCase()],
      });
    }
  },
  { immediate: true },
);

const getLicenseFilter = computed(() => getFilters.value?.licensesFilter);

const statusFilter = computed(() => Object.keys(getFilters.value?.status).filter(x => getFilters.value?.status[x]));

const getAgentsLicenseTypesVisibility = computed(() => {
  if (!GQL_agentsFilterMetadata?.result?.value?.ibManagerEntities) return null;
  return {
    cloudAgent: GQL_agentsFilterMetadata?.result?.value?.ibManagerEntities?.settingsMetadata?.isCloudActivated || false,
    initiator: true,
    helper: true,
  };
});

const setStatusFilter = (value: any) => {
  const changes = Object.keys(getStatusFilter.value).filter(x => (getStatusFilter.value[x] ? !value.includes(x) : value.includes(x)));
  changes.forEach(x => {
    const newValue = !getStatusFilter.value[x];
    matomo?.trackEvent({
      category: 'Agents Filter',
      action: 'Select/ Unselect status type',
      name: x,
      value: newValue ? 1 : 0,
    });
    agentsFilter?.updateFilter({ osType: OsType.Linux, group: 'status', filter: x, value: newValue });
  });
  agentsFilter?.setGQL_LinuxAgentsFilter('statusFilter');
  selectedAgents?.clearSelection();
};

const cpuView = computed(() => getFilters.value.cpuView);
const setCpuView = (value: any) => {
  // store.commit('agents/updateFilter', { osType: OsType.Linux, group: 'cpuView', value });
  agentsFilter?.updateFilter({ osType: OsType.Linux, group: 'cpuView', value });
  agentsFilter?.setGQL_LinuxAgentsFilter('usedCpuFilter');
  selectedAgents?.clearSelection();
};

const cloudStatus = computed(() => GQL_AppDataQuery?.result?.value?.ibManagerEntities?.settings?.common?.cloud?.cloudStatus);

const licensesChips = computed(() => {
  const licenseFilters = {
    cloudAgent: {
      visible: cloudStatus.value && cloudStatus.value !== 'Disabled' && getAgentsLicenseTypesVisibility.value?.cloudAgent,
      enabled: getLicenseFilter.value.cloudAgent,
    },
    helper: {
      visible: true,
      enabled: getLicenseFilter.value.helper,
    },
    initiator: {
      visible: getAgentsLicenseTypesVisibility.value?.initiator,
      enabled: getLicenseFilter.value.initiator,
    },
    bothHelperAndInitiator: {
      visible: getAgentsLicenseTypesVisibility.value?.initiator,
      enabled: getLicenseFilter.value.bothHelperAndInitiator,
    },
  };

  const actualFilters = Object.keys(licenseFilters).reduce((acc, key) => {
    if (licenseFilters[key as keyof typeof licenseFilters].visible) {
      acc[key] = licenseFilters[key as keyof typeof licenseFilters].enabled;
    }
    return acc;
  }, {} as Record<string, boolean>);

  const actualExistingFilters = Object.keys(actualFilters);
  const actualEnabledFilters = actualExistingFilters.filter(key => actualFilters[key]);

  const existingOptionsLength = actualExistingFilters.length;
  const enabledOptionsLength = actualEnabledFilters.length;

  return enabledOptionsLength !== existingOptionsLength ? `${enabledOptionsLength} / ${existingOptionsLength}` : null;
});
const availableCPU = computed(() => (cpuView.value.min || cpuView.value.max < 100 ? `${cpuView.value.min}% - ${cpuView.value.max}%` : null));
const statusFilterChips = computed(() => {
  const statusFilters = Object.keys(getStatusFilter.value);
  const enabledStatusFilters = Object.keys(getStatusFilter.value).filter(status => getStatusFilter.value[status]);
  return enabledStatusFilters.length !== statusFilters.length ? `${enabledStatusFilters.length} / ${statusFilters.length}` : null;
});
const buildGroupChips = computed(() => {
  const buildGroupsLength = getBuildGroups.value?.filter((buildGroup: any) => getFilters.value.buildGroups[buildGroup?.name]).length;
  const allAgentsBuildGroupsLength = getBuildGroups.value?.length;
  return buildGroupsLength !== allAgentsBuildGroupsLength ? `${buildGroupsLength} / ${allAgentsBuildGroupsLength}` : null;
});
const allAgentsBuildGroupsCheckbox = computed(() => {
  let lastVal;
  for (let i = 0; i < getBuildGroups.value?.length; i++) {
    if (lastVal === undefined) lastVal = getFilters.value.buildGroups[getBuildGroups.value[i]?.name || ''];
    else if (lastVal !== getFilters.value.buildGroups[getBuildGroups.value[i]?.name || '']) {
      lastVal = null;
      break;
    }
  }
  if (lastVal) {
    agentsFilter?.clearGQL_AgentsFilter(['buildGroupsFilter']);
  }
  return lastVal;
});
const allStatusCheckbox = computed(() => {
  if (Object.keys(getStatusFilter.value).every(key => getStatusFilter.value[key])) {
    agentsFilter?.clearGQL_AgentsFilter(['statusFilter']);

    return true;
  }
  if (Object.keys(getStatusFilter.value).some(key => getStatusFilter.value[key])) {
    return null;
  }
  return false;
});

const getAppliedFiltersCount = computed(() => (!!statusFilterChips.value as any) + !!availableCPU.value + !!buildGroupChips.value + !!licensesChips.value);

watch(
  () => getAppliedFiltersCount,
  newValue => {
    agentsFilter?.setAgentsLeftDrawerActiveFilters(newValue.value);
  },
  { deep: true },
);

const capitalize = (value: any) => {
  if (!value) return '';
  return value.toString().charAt(0).toUpperCase() + value.slice(1);
};
const cpuViewChanged = (e: any) => {
  setCpuView({ min: e.min, max: e.max });
  if (e.min === 0 && e.max === 100) {
    agentsFilter?.clearGQL_AgentsFilter(['usedCpuFilter']);
  }
  matomo?.trackEvent({
    category: 'Agents Filter',
    action: 'Click on Range Selector - Available CPU',
  });
};
const clearFilters = () => {
  agentsFilter?.clearFilters();
  agentsFilter?.clearGQL_AgentsFilter();
  matomo?.trackEvent({
    category: 'Agents Filter',
    action: 'Clear All',
  });
};

// eslint-disable-next-line no-unused-vars
const scrollToElement = (_ref: any) => {
  /* FEATURE DISABLED AT THE MOMENT */
  // const el = $refs[ref];
  // if (el) {
  //   const scrollInfo = $refs['q-scroll-area'].getScroll();
  //   const elRect = el.getBoundingClientRect();
  //   const isElementFullyVisable = elRect.bottom - scrollInfo.verticalContainerSize < 0;
  //   if (!isElementFullyVisable) {
  //     const container = $refs['q-scroll-area'].getScrollTarget();
  //     const y = elRect.top + container.scrollTop - 98;
  //     $refs['q-scroll-area'].setScrollPosition('vertical', y, 300);
  //   }
  // }
};

return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_scroll_area, {
      ref: "q-scroll-area",
      class: "full-width col-grow",
      "thumb-style": { width: '4px', background: 'rgba(127, 135, 137, 0.4)', right: '2px', opacity: '1', borderRadius: '50px' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_q_list, { class: "filter-list ibf-h5 column" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                ref: "status-container",
                class: _normalizeClass(["filter-list-item shadow-focus-on-div", { 'ibf-oneline2 open': filtersOpen.value.statusOpen }]),
                "data-testid": _unref(elementsIds).agents.filtersMenu.statusFilterExpansionItem
              }, [
                _createVNode(_component_q_expansion_item, {
                  "switch-toggle-side": "",
                  "header-class": "agents-table-filter-list-header focus-be-gone ",
                  "expand-icon": "icon-right-small",
                  "expanded-icon": "icon-down-small",
                  "expand-icon-class": "filter-expand-icon",
                  "default-opened": false,
                  onHide: _cache[2] || (_cache[2] = ($event: any) => (toggleOpenFilter('statusOpen', false))),
                  onBeforeShow: _cache[3] || (_cache[3] = ($event: any) => (toggleOpenFilter('statusOpen', true))),
                  onAfterShow: _cache[4] || (_cache[4] = ($event: any) => (scrollToElement('status-container')))
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_q_item_section, { style: {"width":"80%"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('agentsTable.filters.status.title')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_q_item_section, { side: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(statusFilterChips)), 1)
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _unref(statusFilterChips) && !filtersOpen.value.statusOpen]
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(IncrediCheckBox, {
                        value: _unref(allStatusCheckbox),
                        label: 'All',
                        onInput: _cache[0] || (_cache[0] = (val) => {
                      Object.keys(_unref(getStatusFilter)).forEach(key => (_unref(getStatusFilter)[key] = val));
                      _unref(agentsFilter)?.setGQL_LinuxAgentsFilter('statusFilter');
                      _unref(selectedAgents)?.clearSelection();
                    })
                      }, null, 8, ["value"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getStatusFilter), (item, key) => {
                        return (_openBlock(), _createBlock(IncrediCheckBox, {
                          key: key,
                          "model-value": _unref(statusFilter),
                          class: "q-ml-md",
                          val: key,
                          label: capitalize(String(key) === 'ready' ? 'online' : key),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = (value)=>setStatusFilter(value))
                        }, null, 8, ["model-value", "val", "label"]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ], 10, _hoisted_2),
              _createElementVNode("div", {
                ref: "cpu-container",
                class: _normalizeClass(["filter-list-item shadow-focus-on-div", { 'ibf-oneline2': filtersOpen.value.cpuOpen }])
              }, [
                _createVNode(_component_q_expansion_item, {
                  "switch-toggle-side": "",
                  label: _ctx.$t('agentsTable.filters.cpuLoad.title'),
                  "expand-icon": "icon-right-small",
                  "expanded-icon": "icon-down-small",
                  "expand-icon-class": "filter-expand-icon",
                  "default-opened": false,
                  "header-class": "focus-be-gone agents-table-filter-list-header",
                  onBeforeHide: _cache[5] || (_cache[5] = ($event: any) => (toggleOpenFilter('cpuOpen', false))),
                  onBeforeShow: _cache[6] || (_cache[6] = ($event: any) => (toggleOpenFilter('cpuOpen', true))),
                  onAfterShow: _cache[7] || (_cache[7] = ($event: any) => (scrollToElement('cpu-container')))
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_q_item_section, { style: {"width":"80%"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('agentsTable.filters.cpuLoad.title')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_q_item_section, { side: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(availableCPU)), 1)
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, !filtersOpen.value.cpuOpen && _unref(availableCPU)]
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(RangeSlider, {
                        "label-value": "%",
                        "show-hover-label": false,
                        "min-value": 0,
                        "max-value": 100,
                        value: _unref(cpuView),
                        onHandleChange: cpuViewChanged
                      }, null, 8, ["value"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"])
              ], 2),
              _createElementVNode("div", {
                ref: "license-container",
                class: _normalizeClass(["filter-list-item shadow-focus-on-div license-filter-content", { 'ibf-oneline2 open': filtersOpen.value.licenseOpen }]),
                "data-testid": _unref(elementsIds).agents.filtersMenu.licenseFilterExpansionItem
              }, [
                _createVNode(_component_q_expansion_item, {
                  "switch-toggle-side": "",
                  label: _ctx.$t('agentsTable.filters.license.titleLinux'),
                  "expand-icon": "icon-right-small",
                  "expanded-icon": "icon-down-small",
                  "expand-icon-class": "filter-expand-icon",
                  "default-opened": false,
                  "header-class": ['focus-be-gone', 'filters-license-container'],
                  onBeforeHide: _cache[8] || (_cache[8] = ($event: any) => (toggleOpenFilter('licenseOpen', false))),
                  onBeforeShow: _cache[9] || (_cache[9] = ($event: any) => (toggleOpenFilter('licenseOpen', true))),
                  onAfterShow: _cache[10] || (_cache[10] = ($event: any) => (scrollToElement('license-container')))
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_q_item_section, { style: {"width":"80%"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('agentsTable.filters.license.titleLinux')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_q_item_section, { side: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(licensesChips)), 1)
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _unref(licensesChips) && !filtersOpen.value.licenseOpen]
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      (_unref(getAgentsLicenseTypesVisibility))
                        ? (_openBlock(), _createBlock(AgentsLicenseFilter, {
                            key: 0,
                            visibility: _unref(getAgentsLicenseTypesVisibility)
                          }, null, 8, ["visibility"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["label"])
              ], 10, _hoisted_7),
              _createElementVNode("div", {
                ref: "build-groups-container",
                class: _normalizeClass(["filter-list-item shadow-focus-on-div", { 'ibf-oneline2 open': filtersOpen.value.buildGroupOpen }])
              }, [
                _createVNode(_component_q_expansion_item, {
                  "switch-toggle-side": "",
                  "header-class": "agents-table-filter-list-header focus-be-gone",
                  "expand-icon": "icon-right-small",
                  "expanded-icon": "icon-down-small",
                  "expand-icon-class": "filter-expand-icon",
                  "default-opened": false,
                  onHide: _cache[12] || (_cache[12] = ($event: any) => (toggleOpenFilter('buildGroupOpen', false))),
                  onAfterShow: _cache[13] || (_cache[13] = ($event: any) => (scrollToElement('build-groups-container'))),
                  onBeforeShow: _cache[14] || (_cache[14] = ($event: any) => (toggleOpenFilter('buildGroupOpen', true)))
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_q_item_section, { style: {"width":"80%"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('agentsTable.filters.buildGroups.title')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_q_item_section, { side: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(buildGroupChips)), 1)
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _unref(buildGroupChips) && !filtersOpen.value.buildGroupOpen]
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(IncrediCheckBox, {
                        value: _unref(allAgentsBuildGroupsCheckbox),
                        label: 'All',
                        onInput: _cache[11] || (_cache[11] = (val) => {
                      _unref(getBuildGroups)?.forEach((buildGroup) => _unref(agentsFilter)?.updateFilter({ osType: _unref(OsType).Linux, group: 'buildGroups', filter: buildGroup?.name, value: val }));
                      _unref(agentsFilter)?.setGQL_LinuxAgentsFilter('buildGroupsFilter');
                      _unref(selectedAgents)?.clearSelection();
                      _unref(matomo)?.trackEvent({
                        category: 'Agents Filter',
                        action: 'Select / Unselect Build Groups',
                      });
                    })
                      }, null, 8, ["value"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortBuildGroupsByAlphabetic), (item, key) => {
                        return (_openBlock(), _createBlock(IncrediCheckBox, {
                          key: key,
                          value: !!_unref(getFilters)?.buildGroups[item],
                          class: "q-ml-md",
                          label: item,
                          onInput: (val) => {
                      // store.commit('agents/updateFilter', { osType: OsType.Linux, group: 'buildGroups', filter: item, value: val });
                      _unref(agentsFilter)?.updateFilter({ osType: _unref(OsType).Linux, group: 'buildGroups', filter: item, value: val });
                      _unref(agentsFilter)?.setGQL_LinuxAgentsFilter('buildGroupsFilter');
                      _unref(selectedAgents)?.clearSelection();
                    }
                        }, null, 8, ["value", "label", "onInput"]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ], 2)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["thumb-style"]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_q_btn, {
        style: {"padding":"4px 16px"},
        label: "Clear All",
        class: "ibf-button1 incredi-button-ibx primary-light",
        "no-caps": "",
        unelevated: "",
        "data-testid": _unref(elementsIds).agents.filtersMenu.clearAllFiltersButton,
        onClick: clearFilters
      }, null, 8, ["data-testid"])
    ])
  ]))
}
}

})